// extracted by mini-css-extract-plugin
var _1 = "fEOfr";
export { _1 as "mainModuleStyle" }
